import React from "react";
import { useNavigate } from "react-router-dom";
import { Gift, MessageCircle, ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { logWa } from "../lib/wa";

/* Home strip: every customer becomes an inviter — one tap sends a ready WhatsApp invite with their code; full page at /referral. */
export const InviteStrip = ({ ta }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const code = user?.referral_code;
  const link = `${window.location.origin}/auth?code=${code || ""}`;
  const text = ta
    ? `👑 ROYAL LAKSHMI — Kerala · Dear · Golden Raja lottery app!\n\nநான் இங்க விளையாடுறேன் — result நேரத்துக்கு, winning உடனே wallet-ல 💰\n\nஎன் code: *${code}*\nஇந்த link-ல join பண்ணுங்க 👇\n${link}`
    : `👑 ROYAL LAKSHMI — Kerala · Dear · Golden Raja lottery app!\n\nI play here — results on time, winnings credited instantly 💰\n\nMy code: *${code}*\nJoin with this link 👇\n${link}`;
  const share = (e) => { e.stopPropagation(); if (!user) { navigate("/auth"); return; } logWa({ mobile: "" }, "home_invite"); window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank"); };
  return (
    <div onClick={() => navigate(user ? "/referral" : "/auth")} className="mt-3 rounded-2xl p-3 flex items-center gap-3 cursor-pointer active:scale-[.99] transition-transform rl-gold-border" style={{ background: "linear-gradient(135deg,#0f172a 0%,#1e293b 60%,#78350f 100%)" }} data-testid="invite-strip">
      <div className="w-10 h-10 rounded-xl rl-gold-bg flex items-center justify-center shrink-0"><Gift className="w-5 h-5 text-slate-900" /></div>
      <div className="flex-1 min-w-0 text-white">
        <div className="font-display font-black text-sm leading-tight">{ta ? "நண்பர்களை அழைங்க · ரிவார்டு வாங்குங்க" : "Invite friends · earn rewards"}</div>
        <div className="text-[10px] text-amber-200 truncate">{ta ? `உங்க code ${code || "—"} · நண்பர் recharge பண்ணா உங்களுக்கு bonus` : `Your code ${code || "—"} · bonus when a friend recharges`}</div>
      </div>
      <button onClick={share} className="h-9 px-3 rounded-full bg-emerald-500 text-white text-[11px] font-black flex items-center gap-1 shrink-0" data-testid="invite-strip-wa"><MessageCircle className="w-4 h-4" />{ta ? "அழை" : "Invite"}</button>
      <ChevronRight className="w-4 h-4 text-amber-200 shrink-0" />
    </div>
  );
};
